import { apiPost } from "@/utils/api";

// Never attempt-event-create/: it spends an attempt per call, so keep-alives
// there would terminate a candidate within minutes. ENDED is not sent; the
// server ignores it and closes an episode when keep-alives stop.

const CONTINUES_INTERVAL_MS = 30000;

// Per type: each detector runs one engine, so the type identifies the episode.
const _lastSentAt = new Map();
// Refused with 400/404; retrying would fail identically until a new episode.
const _refused = new Set();

// Failed violation POSTs, reported on the next successful signal because the
// server cannot see a request that never arrived.
let _lostViolations = 0;

export function episodeOpened(type) {
  if (!type) return;
  _lastSentAt.set(type, Date.now());
  _refused.delete(type);
}

export function episodeClosed(type) {
  if (!type) return;
  _lastSentAt.delete(type);
  _refused.delete(type);
}

export function noteLostViolation() {
  _lostViolations += 1;
}

export function resetEpisodeSignals() {
  _lastSentAt.clear();
  _refused.clear();
  _lostViolations = 0;
}

export async function sendContinues({ type, reason, sectionKind }) {
  if (!type || _refused.has(type)) return;

  const now = Date.now();
  const last = _lastSentAt.get(type);
  if (last !== undefined && now - last < CONTINUES_INTERVAL_MS) return;

  const examId = localStorage.getItem("exam_id");
  if (!examId) return;

  _lastSentAt.set(type, now);
  const lost = Math.min(_lostViolations, 1000);

  try {
    await apiPost("/exam-delivery/attempt-event-signal/", {
      exam_id: examId,
      signal: "CONTINUES",
      reason,
      section_kind: sectionKind,
      ...(lost ? { lost_events: lost } : {}),
    });
    // Not zeroed: losses during this request are still owed.
    _lostViolations -= lost;
  } catch (err) {
    console.error("[Proctoring] Episode signal failed:", err);
    const status = err?.response?.status;
    if (status === 400 || status === 404) _refused.add(type);
  }
}
